export default __webpack_public_path__ + "static/maro.banner-841de47a8ff4ac4eab70abee26cdea24.jpg";